import React from 'react';
import clsx from 'clsx';
import { TableTabs } from '@colonist/ui-platform';
import { useContainerQuery } from '@colonist/ui';
import { RankedModeSelector } from './RankedModeSelector/RankedModeSelector.tsx';
import { RankedTable } from './RankedTable/RankedTable.tsx';
import { SeasonProgress } from './SeasonProgress/SeasonProgress.tsx';
import { BottomCtaButtons } from './BottomCtaButtons/BottomCtaButtons.tsx';
import styles from './LeaderboardsPage.module.scss';
const NARROW_BREAKPOINT_PX = 767;
const TALL_HEIGHT_PX = 500;
const query = {
    isNarrow: {
        maxWidth: NARROW_BREAKPOINT_PX
    },
    isTall: {
        minHeight: TALL_HEIGHT_PX
    },
    isPortrait: {
        orientation: 'portrait'
    }
};
const LAYOUTS = {
    sidebar: {
        modeSelectorDirection: 'vertical',
        hideModeText: false,
        seasonProgressPlacement: 'sidebar',
        tabSize: 'md',
        isRootNarrow: false,
        isSearchNarrow: false,
        filterCtaToActiveMode: false
    },
    topTabs: {
        modeSelectorDirection: 'horizontal',
        hideModeText: true,
        seasonProgressPlacement: 'bottom',
        tabSize: 'sm',
        isRootNarrow: true,
        isSearchNarrow: true,
        filterCtaToActiveMode: true
    },
    iconRail: {
        modeSelectorDirection: 'vertical',
        hideModeText: true,
        seasonProgressPlacement: 'bottom',
        tabSize: 'sm',
        isRootNarrow: false,
        isSearchNarrow: true,
        filterCtaToActiveMode: true
    }
};
export const LeaderboardsPage = ({ rowData, myRowData, moreDataAvailable, unrankedMessage, emptyText, leaderboards, enabledRankedModeIds, activeRankedModeId, activeLeaderboardUrl, searchNode, seasonStartDate, seasonEndDate, onRankedModeChange, onLeaderboardChange, fetchMoreData, onClickRow, onClickLogin, onClickLocationFlag, onClickDivisionIcon, onClickMembershipIcon, isUserOnDiscord, ctaConfig })=>{
    const [{ isNarrow, isTall, isPortrait }, containerRef] = useContainerQuery(query);
    const getLayout = ()=>{
        if (!isNarrow) return 'sidebar';
        if (isPortrait) return 'topTabs';
        return 'iconRail';
    };
    const { modeSelectorDirection, hideModeText, seasonProgressPlacement, tabSize, isRootNarrow, isSearchNarrow, filterCtaToActiveMode } = LAYOUTS[getLayout()];
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: clsx(styles.leaderboardsPage, isRootNarrow && styles.narrow)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.sideSection
    }, /*#__PURE__*/ React.createElement(RankedModeSelector, {
        activeModeId: activeRankedModeId,
        modeIds: enabledRankedModeIds,
        onModeChange: onRankedModeChange,
        direction: modeSelectorDirection,
        hideText: hideModeText
    }), seasonProgressPlacement == 'sidebar' && /*#__PURE__*/ React.createElement(SeasonProgress, {
        startDate: seasonStartDate,
        endDate: seasonEndDate,
        size: "md"
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.mainSection
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.tabsContainer
    }, /*#__PURE__*/ React.createElement(TableTabs, {
        activeTabId: activeLeaderboardUrl,
        tabs: leaderboards,
        onTabChange: onLeaderboardChange,
        size: tabSize
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.search, isSearchNarrow && styles.narrow)
    }, searchNode)), /*#__PURE__*/ React.createElement(RankedTable, {
        data: rowData,
        myRowData: myRowData,
        fetchMoreData: fetchMoreData,
        moreDataAvailable: moreDataAvailable,
        unrankedMessage: unrankedMessage,
        emptyText: emptyText,
        onClickRow: onClickRow,
        onClickLogin: onClickLogin,
        onClickLocationFlag: onClickLocationFlag,
        onClickDivisionIcon: onClickDivisionIcon,
        onClickMembershipIcon: onClickMembershipIcon,
        isUserOnDiscord: isUserOnDiscord
    }), isTall && /*#__PURE__*/ React.createElement("div", {
        className: styles.bottom,
        "data-testid": "leaderboard-bottom"
    }, seasonProgressPlacement == 'bottom' && /*#__PURE__*/ React.createElement(SeasonProgress, {
        startDate: seasonStartDate,
        endDate: seasonEndDate,
        size: "sm"
    }), /*#__PURE__*/ React.createElement(BottomCtaButtons, {
        onClickBaseGame: ctaConfig.onClickBaseGame,
        onClick1v1: ctaConfig.onClick1v1,
        onClickCK: ctaConfig.onClickCK,
        onClickColonistRush: ctaConfig.onClickColonistRush,
        activeModeId: filterCtaToActiveMode ? activeRankedModeId : undefined
    }))));
};
